<script setup>
  import { ref, computed, watchEffect} from 'vue';

  const props = defineProps({
    units: {
      type: String,
      required: true
    },
    graph: {
      type: [Object, null],
      required: true
    }
  });

  const labelStyle = computed(() => {
    return {
      left: `${props.graph.plotLeft / 2}px`,
      top: `5px`,
    };
  });
</script>

<template>
  <Teleport :to="graph.container">
    <p
      class="jwx-tide-graph__unit-display"
      :style="labelStyle"
    >{{ props.units }}</p>
  </Teleport>
</template>